// SPDX-License-Identifier: AGPL-3.0-or-later
import type React from 'react';
export const SHIFT_KEY_SYMBOL = '\u21E7';
export function handleStopPropagationForKeyboardActivation(e: React.KeyboardEvent): void {
	if (e.key === 'Enter' || e.key === ' ') {
		e.stopPropagation();
	}
}
export function stopPropagationOnEnterSpace(e: React.KeyboardEvent): void {
	if (e.key === 'Enter' || e.key === ' ') {
		e.stopPropagation();
	}
}
